import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FsNavModule } from '@firestitch/nav';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FsNavModule, MatIcon],
})
export class NavbarComponent {

}
